export const similarItemsSelector = (state) => state.ordering.similarItems;
